
import React from 'react';

import { IFormItemProps } from '@/components';
import { IPhase } from '@/interface';

import styles from './index.module.less';
import Item from './item';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

export const CustomPhase2: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: IPhase[];
  onChange: (value: IPhase[]) => {};
  disabled?: boolean;
  placeholder?: string;
} & IFormArrayProps
> = (props) => {
  const {
    value = [{ character: '' }],
    onChange,
    disabled = false,
  } = props;

  return (
    <div className={styles.wrapper}>
      <Item
        disabled={disabled}
        placeholder={props.placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
